import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "./use-redux";

import type { Dispatch, SetStateAction } from "react";

import { handleDarkMode } from "~/store/layout";

interface UseDarkmodeOutput {
  theme: string | null;
  isDark: boolean;
  setDarkMode: Dispatch<SetStateAction<boolean>>;
}

enum Theme {
  DARK = "dark",
  LIGHT = "light",
}

const useDarkmode = (): UseDarkmodeOutput => {
  const dispatch = useAppDispatch();
  const isDark: boolean = useAppSelector((state) => state.layout.darkMode);
  const [theme, setTheme] = useState<Theme | null>(Theme.LIGHT);

  // ** Return a wrapped version of useState's setter function
  const setDarkMode: any = (mode: boolean): void => {
    dispatch(handleDarkMode(mode));
  };

  useEffect(() => {
    // ** Check if dark mode is enabled
    if (isDark) {
      setTheme(Theme.DARK);
    } else {
      setTheme(Theme.LIGHT);
    }
  }, [isDark, setTheme]);

  return { theme, isDark, setDarkMode };
};

export default useDarkmode;
